import { ComponentInstall } from "../../utils";
import ColorPicker from "./src";

export default ComponentInstall(ColorPicker);
